module.exports = "/assets/data/69db33a711955be46a141a6b5c84a091-DD4.data.json";